import styled from '@emotion/styled';
import { formatDateAndTime } from '@racemap/utilities/formatting';
import { currentEventTimes } from '@racemap/utilities/functions/event';
import { isContestGroupEvent } from '@racemap/utilities/functions/utils';
import type { RacemapEvent } from '@racemap/utilities/types/events';
import type { Immutable } from 'immer';
import type { FC } from 'react';

interface Props {
  event: Immutable<RacemapEvent>;
  compact?: boolean;
}

export const EventTimes: FC<Props> = ({ event, compact = false }) => {
  const isContestGroup = isContestGroupEvent(event);

  const visibleElements = event?.modules.timing.visibleElements;
  const [startTimestamp, endTimestamp] = currentEventTimes(event);
  if (!visibleElements.eventTimes || isContestGroup) return <></>;

  return (
    <Container compact={compact}>
      <DateEntry>
        <b>Start:</b> {formatDateAndTime(startTimestamp, true)}
      </DateEntry>
      <DateEntry>
        <b>End:</b> {formatDateAndTime(endTimestamp, true)}
      </DateEntry>
    </Container>
  );
};

const Container = styled.div<{ compact: boolean }>`
  display: flex;
  justify-content: space-around;
  font-size: 1em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: rgba(0, 0, 0, 0.65);
  flex-direction: column;
  align-items: flex-start;

  @media screen and (min-width: 576px) {
    flex-direction: row;
    justify-content: flex-start;
    font-size: 1.1em;
  }

  ${({ compact }) =>
    compact &&
    `
    flex-direction: row;
    justify-content: space-between !important;
  `}
`;

const DateEntry = styled.div`
  padding-right: 5px;
`;
